import ViewCircuitForm from '@/components/circuits/ViewCircuitForm';
import Loader from '@/components/ui/Loader';
import {
  useGetCircuit,
  useGetCircuitParagraphOverrides,
} from '@/hooks/useCircuits';
import { useResourceLanguage } from '@/hooks/useResourceLanguage';
import { memo } from 'react';
import { useParams } from 'react-router';

const ViewCircuitFormMemo = memo(ViewCircuitForm);

const ViewCircuitPage = () => {
  const { circuitId = '' } = useParams();

  const { language, setLanguage } = useResourceLanguage();

  const {
    data: circuitData,
    isLoading,
    isSuccess,
  } = useGetCircuit(circuitId, true);

  const { data: paragraphOverrides } =
    useGetCircuitParagraphOverrides(circuitId);

  return isLoading ? (
    <Loader />
  ) : (
    isSuccess && (
      <ViewCircuitFormMemo
        circuit={circuitData}
        language={language}
        setLanguage={setLanguage}
        paragraphOverrides={paragraphOverrides}
        key={`circuit-${circuitData.id}`}
      />
    )
  );
};

export default ViewCircuitPage;
